/** @jsx h */

import { h, render } from "preact";
import Intro from "./components/Intro";
import "./styles.css";
import About from "./components/About";
import Slider from "./components/Slider";
import GithubPreview from "./components/GithubPreview";
import Resume from "./components/Resume";
import Footer from "./components/Footer";
import useWindowSize from "./hooks/useWindowSize";
import reactS from "./assets/logos/frontend/reactS.svg";

const github = {
  pic: reactS,
  name: "react-context-middleware",
  description:
    "Learned about writing redux middleware, decided to try to build it for the Context API.",
  link: `https://github.com/CallMeHK/context-middleware-testing`
};

function App() {
  const size = useWindowSize();

  return (
    <div className="intro">
      <div className="container">
        <Intro />
        <About />
        <Slider />
        <div className="github">
          <GithubPreview {...github} />
          <Resume />
        </div>
      </div>
      <Footer />
    </div>
  );
}

// render an instance of Clock into <body>:
render(<App />, document.body);
